<template>
  <div class="modal-window bds067">
    <header class="modal-header">
      <div class="tit">OKR</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="okr-cnt">
        <div class="top clear">
          <div class="dropdown ty2 relative fl" v-if="qrtList.length > 0">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">{{
                  currentQrt.qrtTopMsg
                }}</v-btn>
              </template>
              <div class="dropdown-list">
                <div
                  class="dropdown-list-item"
                  v-for="(item, index) in qrtList"
                  :key="'qrt' + index"
                >
                  <div class="tit">
                    <button
                      type="button"
                      class=""
                      @click="qrtChange(item.QRT_CD, $event)"
                    >
                      {{ item.QRT_TOP_MSG }}
                    </button>
                  </div>
                </div>
              </div>
            </v-menu>
          </div>
          <button type="button" class="btn_link_add fr" @click="LinkedOkrPopup">
            {{ $i18nUtil.trans("button.okr.add","OKR 연결 추가") }}
          </button>
        </div>

        <div class="scroll">
          <!-- <dl>
            <dt>연결된 나의 OKR</dt>
            <dd>
              <ul>
                <li class="nodata" v-if="countMyOkrList == 0">
                  연결된 OKR이 없습니다.
                </li>
                <li
                  v-else
                  v-for="(item, index) in projectOkrLinkList"
                  :key="'myOkr' + index"
                >
                  <div class="clear" v-if="item.regUserId == loginUserId">
                    <div class="fl kr">{{ ChangeOkrType(item.okrType) }}</div>
                    <button
                      type="button"
                      class="fr unlink"
                      @click="
                        OkrDisconnection(item.projectId, item.projectOkrLinkId)
                      "
                    >
                      연결 해제
                    </button>
                  </div>
                  <div class="tit" v-if="item.regUserId == loginUserId">
                    {{ item.okrTitle }}
                  </div>
                </li>
              </ul>
            </dd>
          </dl> -->
          <dl>
            <!-- <dt>연결된 임직원 OKR</dt> -->
            <dd>
              <ul>
                <li class="nodata" v-if="projectOkrLinkList.length == 0">
                  {{ $i18nUtil.trans("message.OkrListPopup.001","연결된 OKR이 없습니다.") }}
                </li>
                <li
                  v-else
                  v-for="(item, index) in projectOkrLinkList"
                  :key="'okr' + index"
                  :class="{ disabled: item.holdYn == 1 }"
                >
                  <div class="clear">
                    <div class="fl kr">{{ ChangeOkrType(item.okrType) }}</div>
                    <div class="droplayer tooltipmember relative fl">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on"
                            ><b>{{ item.regUserName }}</b></v-btn
                          >
                        </template>
                        <div class="dropdown-list">
                          <UserTooltip :userId="item.regUserId" />
                        </div>
                      </v-menu>
                    </div>
                    <div
                      class="dividing_line_ty3"
                      v-if="item.holdYn == 1"
                    ></div>
                    <div class="icon-txt-pause" v-if="item.holdYn == 1">
                      {{ $i18nUtil.trans("button.okr.pause","일시정지") }}
                    </div>
                    <button
                      type="button"
                      class="fr unlink"
                      v-if="item.regUserId == loginUserId"
                      @click="
                        OkrDisconnection(item.projectId, item.projectOkrLinkId)
                      "
                    >
                      {{ $i18nUtil.trans("button.okr.terminateConn","연결 해제") }}
                    </button>
                  </div>
                  <div class="tit">
                    {{ item.okrTitle }}
                  </div>
                </li>
              </ul>
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <!-- 
        <footer class="modal-footer">
            <button type="button" class="btn_ty1">저장</button>
        </footer> -->
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import LinkedOkr from "@/components/cowork/general/project/modal/LinkedOkr";
import EventBus from "@/js/eventbus/eventBus";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
export default {
  components: {
    UserTooltip,
  },
  data() {
    return {
      loginUserId: "",
      projectOkrLinkList: [],
      countMyOkrList: 0,
      countOkrList: 0,
      qrtList: [],
      currentQrt: {
        qrtCd: "",
        qrtTopMsg: "",
      },
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.getQrtList();
    EventBus.$off("closeOkrLinkPopup");
    EventBus.$on("closeOkrLinkPopup", () => {
      this.getProjectOkrLink(this.currentQrt.qrtCd);
    });
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal"]),
    ...mapActions("modals", ["showToast"]),
    getQrtList() {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/okr/getProjectQrtList",
        method: "post",
        params: {
          projectId: this.modalInfo.projectId,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((data) => {
          if (!data.errCode) {
            obj.qrtList = data.result;
            let currQrtCheck = false;
            for (let i = 0; i < obj.qrtList.length; i++) {
              if (obj.qrtList[i].CURR_QRT_YN == 1) {
                currQrtCheck = true;
                obj.currentQrt.qrtCd = obj.qrtList[i].QRT_CD;
                obj.currentQrt.qrtTopMsg = obj.qrtList[i].QRT_TOP_MSG;
                obj.getProjectOkrLink(obj.qrtList[i].QRT_CD);
                break;
              }
            }

            if (!currQrtCheck && obj.qrtList.length > 0) {
              obj.currentQrt.qrtCd = obj.qrtList[0].QRT_CD;
              obj.currentQrt.qrtTopMsg = obj.qrtList[0].QRT_TOP_MSG;
              obj.getProjectOkrLink(obj.qrtList[0].QRT_CD);
            }
            // if (obj.qrtList.length == 0) {
            //   obj.setProjectOkrLinkList([]);
            //   obj.setProjectOkrLinkCount(0);
            // }
          }
        })
        .catch((err) => {
          console.log(err);
          // alert("getQrtList fail");
        });
    },
    qrtChange(qrtCd, event) {
      this.currentQrt.qrtCd = qrtCd;
      this.currentQrt.qrtTopMsg = event.target.innerText;
      this.getProjectOkrLink(qrtCd);
    },
    /* okr 연결 목록 */
    getProjectOkrLink(qrtCd) {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/okr/getProjectOkrList",
        method: "post",
        params: {
          projectId: this.modalInfo.projectId,
          qrtCd: qrtCd,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (!res.errorCode) {
            obj.projectOkrLinkList = res.result.data;
            obj.loginUserId = res.result.loginUserId;
            obj.projectOkrLinkList.forEach((value) => {
              if (value.regUserId == obj.loginUserId) {
                obj.countMyOkrList = obj.countMyOkrList + 1;
              } else {
                obj.countOkrList = obj.countOkrList + 1;
              }
            });
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    LinkedOkrPopup() {
      const startDate = new Date(
        this.modalInfo.startDate.substring(0, 4) +
          "-" +
          this.modalInfo.startDate.substring(4, 6) +
          "-" +
          this.modalInfo.startDate.substring(6)
      );
      const endDate = new Date(
        this.modalInfo.endDate.substring(0, 4) +
          "-" +
          this.modalInfo.endDate.substring(4, 6) +
          "-" +
          this.modalInfo.endDate.substring(6)
      );
      const modalInfo = {
        title: this.$i18nUtil.trans("title.LinkedOkr.001","OKR연결 추가"),
        width: "800px",
        height: "743px",
        obj: this.$modal,
        projectId: this.modalInfo.projectId,
        projectName: this.modalInfo.projectName,
        publicYn: this.modalInfo.publicYn.toString(),
        startDate: startDate,
        endDate: endDate,
        type: "OkrLink",
        component: LinkedOkr,
      };
      this.showModal(modalInfo);
    },
    /* okr 연결 해제 */
    OkrDisconnection(projectId, id) {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/okr/deleteProjectOkrLink",
        method: "post",
        params: {
          projectId: this.modalInfo.projectId,
          projectOkrLinkId: id,
          qrtCd: this.currentQrt.qrtCd,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          console.log(res);
          if (!res.errorCode) {
            obj.okrLinkList = res.result.data;
            obj.loginUserId = res.result.loginUserId;
            obj.getProjectOkrLink(obj.currentQrt.qrtCd);
            obj.$emit("closeOkrLinkPopup");
            obj.toastInfo.message = obj.$i18nUtil.trans("TB081");
            obj.showToast(obj.toastInfo);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    ChangeOkrType(type) {
      let resultType = "";
      if (type == "MO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.MO","개인 O");
      } else if (type == "UO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.UO","유닛 O");
      } else if (type == "TO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.TO","팀 O");
      } else if (type == "HO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.HO","본부 O");
      } else if (type == "CO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.CO","회사 O");
      } else if (type == "MK") {
        resultType = this.$i18nUtil.trans("message.project.OKR.MK","개인 KR");
      } else if (type == "UK") {
        resultType = this.$i18nUtil.trans("message.project.OKR.UK","유닛 KR");
      } else if (type == "TK") {
        resultType = this.$i18nUtil.trans("message.project.OKR.TK","팀 KR");
      } else if (type == "HK") {
        resultType = this.$i18nUtil.trans("message.project.OKR.HK","본부 KR");
      } else {
        resultType = this.$i18nUtil.trans("message.project.OKR.else","회사 KR");
      }
      return resultType;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/OkrListPopup.vue